export default __webpack_public_path__ + "static/media/agent1.c3f94521.png";